import { FormPackageLinkModel } from "../../DTOtemp";
import SecureClient from "../SecureClient";

export class FormPackageLinksClient extends SecureClient {
	private _urlBase: string

	constructor() {
		super()
		this._urlBase = `form-packages/form-package-links`
	}

	public getFormPackageLinks(packageId = 0) {
		return this._api.get<FormPackageLinkModel[]>(`${this._urlBase}`, {
			params: {
				packageId
		
			},
			headers: {
				...this.authorizationHeader,
				...this.acceptHeader()
			}
		})
	}

	public getLink(linkId: string) {
		return this._api.get<FormPackageLinkModel>(`${this._urlBase}/${linkId}`, {
			headers: {
				...this.acceptHeader()
			}
		})
	}

	public createLink(formPackageId: number, authenticationProviderId: number | string, description?: string) {
		return this._api.post<FormPackageLinkModel>(`${this._urlBase}/${authenticationProviderId}`, {
			formPackageId,
			description: description ?? ""
		}, {
			headers: {
				...this.authorizationHeader,
				...this.acceptHeader()
			}
		})
	}

	public deleteLink(linkId: number) {
		return this._api.delete(`${this._urlBase}/${linkId}`, {
			headers: {
				...this.authorizationHeader,
				...this.acceptHeader()
			}
		})
	}




}